module.exports = __webpack_public_path__ + "static/media/full-house-md.284df3ea.png";